import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link, withRouter } from 'react-router-dom'
import { Row, Col, Layout, Menu, Icon, Modal, Button, Tooltip } from 'antd'
import LangContext from 'modules/shared/context/langContext'
import * as authActions from 'modules/auth/actions'
import {
  clearFlashMessage,
  loadNotificationCount,
  removeUIState,
} from 'modules/ui/actions'
import styled from 'styled-components'
import { ReactComponent as AlertIcon } from './assets/Alert.svg'
import { ReactComponent as MapIcon } from './assets/Map.svg'
import { ReactComponent as VideoIcon } from './assets/Video.svg'

const SubMenu = Menu.SubMenu
const MenuItemGroup = Menu.ItemGroup
const { Header: H } = Layout
const StyledHearder = styled(H)`
  background: white;
  height: 45px;
`

const MENUS = [
  {
    icon: <Icon component={AlertIcon} />,
    label: 'LCC',
    path: '/logistic-command-center/alert-dashboard',
  },
  {
    icon: <Icon component={VideoIcon} />,
    label: 'Livestream',
    path: '/logistic-command-center/livestream',
  },
  {
    icon: <Icon component={MapIcon} />,
    label: 'Infographic Map',
    path: '/logistic-command-center/infographic-map',
  },
  {
    icon: <Icon type="unordered-list" />,
    label: 'Manual Choice',
    path: '/logistic-command-center/manual-choice',
  },
  {
    icon: <Icon type="setting" />,
    label: 'Config',
    path: '/logistic-command-center/config',
  },
]

class Header extends Component {
  static contextType = LangContext

  state = {
    collapsed: true,
    notiCount: 0,
    haveNewNoti: false,
    inputLng: '',
    visibleNotification: false,
    dataNoti: [],
    countAppoveRequestToUseVehicle: 0,
  }

  _isMounted = false

  logoutAzure = () => {
    window.location.href =
      'https://login.microsoftonline.com/5db8bf0e-8592-4ed0-82b2-a6d4d77933d4/oauth2/logout?post_logout_redirect_uri=' +
      process.env.REACT_APP_REDIRECT_URI
  }

  logoutJ2C = () => {
    window.location.href =
      'https://api-cpac.scg.com/auth/logout?redirect=' +
      process.env.REACT_APP_REDIRECT_URI
  }

  logoutCpac = () => {
    let userAuthen = localStorage.getItem('userAuthen')
    switch (userAuthen) {
      case 'Azure':
        this.logoutAzure()
        break
      case 'J2C':
        this.logoutJ2C()
        break
      default:
    }
  }

  onRemoveCredentials = () => {
    if (typeof this.props.profile !== 'undefined') {
      this.updateUserHistoryLog()
    }
    this.logoutCpac()
    this.props.removeCredentials()
    this.props.removeUIState()
    localStorage.setItem('count-appove-request-vehicle', 0)
    localStorage.setItem('callbackUrl', this.props.location.pathname)
    localStorage.removeItem('notification-settings')
  }

  updateUserHistoryLog = () => {
    axios
      .post(
        `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/updatelogonhistory`,
        {
          id: this.props.profile.user_history_logon_id,
        },
        {
          headers: { Authorization: `Bearer ${this.props.accessToken}` },
        },
      )
      .then(res => {})
  }

  onDismiss = () => {
    this.props.clearFlashMessage()
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    })
  }

  getNoticeData = (langContext, notices) => {
    if (notices.length === 0) {
      return []
    }
    const newNotices = notices.map(notice => {
      let newNotice = {
        ...notice,
        datetime: null,
        title: (
          <Link to={notice.path}>
            {
              langContext[notice.matching_name.charAt(0).toLowerCase()][
                notice.matching_name
              ]
            }
          </Link>
        ),
        avatar:
          'https://gw.alipayobjects.com/zos/rmsportal/GvqBnKhFgObvnSGkDsje.png',
        extra: (
          <Button
            style={{ marginTop: '0px' }}
            size="small"
            icon="delete"
            onClick={() =>
              this.props.deleteFavoriteMenu(
                {
                  userId: this.props.profile.id,
                  favId: newNotice.id,
                  accessToken: this.props.accessToken,
                },
                () => false,
              )
            }
          />
        ),
      }

      // transform id to item key
      if (newNotice.id) {
        newNotice.key = newNotice.id
      }

      return newNotice
    })

    return newNotices
  }

  fetchData = async () => {
    const formData = new FormData()
    formData.append('user_id', this.props.profile.id)
    await fetch(`${process.env.REACT_APP_GO_API_ENDPOINT}/notification/get`, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(response => response.json())
      .then(data => {
        this.setState({
          dataNoti: data.data,
          countNoti: data.count,
        })
        localStorage.setItem('count-noti', data.count)
      })
  }

  fetchCountAppoveRequestToUseVehicle = async () => {
    await fetch(
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/vehicle-share-available-account/notification`,
      {
        method: 'POST',
        body: JSON.stringify({
          vehicleVisibility: this.props.profile.vehicle_visibility,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${this.props.accessToken}`,
        },
      },
    )
      .then(response => response.json())
      .then(data => {
        if (data.status === 200) {
          this.setState({
            countAppoveRequestToUseVehicle: data.data,
          })
          localStorage.setItem('count-appove-request-vehicle', data.data)
        } else {
          console.log('API ERRORS')
        }
      })
  }

  componentDidMount() {
    this._isMounted = true
    let self = this
    let { tokenExp } = this.props
    let timeNow = Date.now()

    this.fetchData()
    this.fetchCountAppoveRequestToUseVehicle()

    if (typeof tokenExp == 'undefined' || tokenExp == null || tokenExp == '') {
      //   console.log('Token Expired')

      setTimeout(function() {
        self.modal(
          <LangContext.Consumer>
            {i18n => i18n.n.notification}
          </LangContext.Consumer>,
          <LangContext.Consumer>
            {i18n => i18n.t.tokenExpired}
          </LangContext.Consumer>,
        )
      }, 500)
    } else if (Math.floor(timeNow / 1000) < tokenExp) {
      let diffTime = (tokenExp - Math.floor(timeNow / 1000)) * 1000
      this.tokenExpTimeout = setTimeout(function() {
        // console.log('Token Expired')
        self.modal(
          <LangContext.Consumer>
            {i18n => i18n.n.notification}
          </LangContext.Consumer>,
          <LangContext.Consumer>
            {i18n => i18n.t.tokenExpired}
          </LangContext.Consumer>,
        )
      }, diffTime)
    }

    if (typeof this.props.profile.id != 'undefined')
      this.props.loadFavoriteMenu({
        userId: this.props.profile.id,
        accessToken: this.props.accessToken,
        loading: false,
      })

    this.setState({
      inputLng: 'th',
    })
  }

  componentWillUnmount() {
    this._isMounted = false
    clearInterval(this.tokenExpTimeout)
  }

  checkSelectLang = inputLng => {
    this.props.changeLang(inputLng)
    if (inputLng == 'en') {
      this.setState({
        inputLng: 'us',
      })
    } else {
      this.setState({
        inputLng: 'th',
      })
    }
  }

  modal = (title, content) => {
    this.onRemoveCredentials()
    Modal.warning({
      title: title,
      okText: 'Ok',
      okType: 'default',
      onOk() {
        // window.location.href = "/";
      },
      content: content,
    })
  }

  handleVisibleChange = visibleNotification => {
    this.setState({
      visibleNotification,
    })
  }

  handleUnVisibleChange = () => {
    this.setState({
      visibleNotification: false,
    })
  }

  render() {
    localStorage.length == 1 && window.location.reload()
    const { done, flash } = this.props

    let firstName = JSON.parse(localStorage.getItem('profile')).firstname
      ? JSON.parse(localStorage.getItem('profile')).firstname
      : ''
    let lastName = JSON.parse(localStorage.getItem('profile')).lastname
      ? JSON.parse(localStorage.getItem('profile')).lastname
      : ''

    return (
      <Fragment>
        <StyledHearder>
          <audio id="audio-alert">
            <source src="/audio/alert/serious-strike.mp3" type="audio/mpeg" />
          </audio>
          <audio id="audio-sos">
            <source src="/audio/alert/sos.mp3" type="audio/mpeg" />
          </audio>
          <audio id="audio-notification">
            <source
              src="/audio/notification/slow-spring-board.mp3"
              type="audio/mpeg"
            />
          </audio>

          <Row
            type="flex"
            justify="space-between"
            align="middle"
            style={{
              lineHeight: '20px',
              padding: '0px 0px 0px 0px',
              margin: '0px 0px 0px 0px',
              borderBottom: '4px solid #1890ff',
            }}
          >
            <Col xs={8} sm={2} md={2} lg={2} xl={2}>
              <Link to={'/'}>
                <img
                  style={{ width: '55px', marginLeft: '16px' }}
                  src="/img/CpacIcon.png"
                  alt=""
                />
              </Link>
            </Col>

            <Col
              sm={16}
              md={22}
              lg={22}
              xl={22}
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <div>
                {this.props.profile.company_id === 54 && (
                  <Menu
                    selectedKeys={[window.location.pathname]}
                    onSelect={({ key }) => window.open(key, '_blank')}
                    mode="horizontal"
                  >
                    {MENUS.map(item => (
                      <Menu.Item key={item.path}>
                        {item.icon}
                        {item.label}
                      </Menu.Item>
                    ))}
                  </Menu>
                )}
              </div>

              <Menu
                theme="light"
                mode="horizontal"
                style={{
                  height: '46px',
                }}
                align="right"
              >
                <SubMenu
                  style={{ width: '220px' }}
                  className="ant-top-menu "
                  title={
                    <div>
                      <Row style={{ height: '46px' }}>
                        <Col xs={1} sm={1} md={1} lg={2} xl={2}>
                          <Icon
                            type="user"
                            style={{
                              fontSize: '16px',
                              color: '#1890ff',
                            }}
                          />
                        </Col>
                        <Col
                          xs={0}
                          sm={0}
                          md={23}
                          lg={20}
                          xl={20}
                          style={{ height: '46px' }}
                        >
                          <Tooltip
                            placement="bottom"
                            title={firstName + ' ' + lastName}
                            arrowPointAtCenter
                          >
                            <Row
                              style={{
                                margin: '-11px 0px 0px 20px',
                                color: '#1890ff',
                              }}
                            >
                              {JSON.parse(localStorage.getItem('profile'))
                                .username.length > 20
                                ? JSON.parse(
                                    localStorage.getItem('profile'),
                                  ).username.substr(0, 19) + '...'
                                : JSON.parse(localStorage.getItem('profile'))
                                    .username}
                            </Row>
                            <Row
                              style={{
                                margin: '-27px 0px 0px 20px',
                                color: '#1890ff',
                              }}
                            >
                              {(firstName + ' ' + lastName).length > 20
                                ? (firstName + ' ' + lastName).substr(0, 19) +
                                  '...'
                                : firstName + ' ' + lastName}
                            </Row>
                          </Tooltip>
                        </Col>
                      </Row>
                    </div>
                  }
                >
                  <MenuItemGroup
                    title={<span className="semi-bold-16">Account</span>}
                    style={{}}
                  >
                    {done ? (
                      <Menu.Item
                        key="menu:1"
                        onClick={this.onRemoveCredentials}
                        style={{ paddingLeft: '14px' }}
                      >
                        <Icon type="logout" style={{ color: 'black' }} />
                        <span style={{ fontSize: '14px', color: 'black' }}>
                          <LangContext.Consumer>
                            {i18n => i18n.l.logout}
                          </LangContext.Consumer>
                        </span>

                        <Link to="/" />
                      </Menu.Item>
                    ) : (
                      <Menu.Item key="menu:1" style={{ paddingLeft: '14px' }}>
                        <span style={{ fontSize: '14px' }}>
                          <LangContext.Consumer>
                            {i18n => i18n.l.login}
                          </LangContext.Consumer>
                        </span>

                        <Link to="/" />
                      </Menu.Item>
                    )}
                  </MenuItemGroup>
                </SubMenu>
              </Menu>
            </Col>
          </Row>
        </StyledHearder>
      </Fragment>
    )
  }
}

const mapStateToProps = ({
  auth: { accessToken, done, profile, tokenExp, favoriteMenu },
  ui: { flash, lastestNotificationAt },
}) => ({
  accessToken,
  done,
  profile,
  flash,
  lastestNotificationAt,
  tokenExp,
  favoriteMenu,
})
const mapDispatchToProps = {
  loadFavoriteMenu: authActions.loadFavoriteMenu.request,
  removeCredentials: authActions.removeCredentials,
  removeUIState: removeUIState,
  loadCredentials: authActions.loadCredentials,
  clearFlashMessage: clearFlashMessage,
  loadNotificationCount: loadNotificationCount.request,
  deleteFavoriteMenu: authActions.deleteFavoriteMenu.request,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header))
